import type { Reducer } from 'redux';
import { produce } from 'immer';
import { defaultState, Fields } from './RestartMachineState';
import type { RestartMachineActions } from './actions.types';
import RestartMachineConstants from '../../components/RestartMachine/constants';

const reducer: Reducer<Fields, RestartMachineActions> = (state = defaultState, action) => {
  return produce<Fields>(state, (draft) => {
    switch (action.type) {
      case RestartMachineConstants.CLOSE_RESTART_MACHINE_MODAL:
        return { ...state, isModalOpen: false };

      case RestartMachineConstants.OPEN_RESTART_MACHINE_MODAL:
        return {
          ...defaultState,
          isModalOpen: true,
          machineId: action.machineId,
          machineName: action.machineName,
        };

      case RestartMachineConstants.SHOW_RESTART_MACHINE_ERROR_BANNER:
        draft.hasError = true;
        draft.error = action.error;
        return draft;

      case RestartMachineConstants.DISMISS_RESTART_MACHINE_ERROR_BANNER:
        draft.hasError = false;
        draft.error = undefined;
        return draft;

      default:
        return state;
    }
  });
};

export default reducer;
